/* Grip trainer add-to-cart.
 *
 * Adds the chosen pack, then opens the theme's slide-out cart so the shopper
 * sees what they added and can keep browsing. (It used to jump straight to
 * checkout, from back when the grip trainer ran on its own isolated layout and
 * the shared drawer was not available to it.)
 *
 * Deliberately a plain script, not an ES module: module scripts here import
 * bare specifiers like "@theme/..." which only resolve through the theme's
 * import map, and a silent resolve failure once left this button doing nothing.
 */
(function () {
  "use strict";

  var SECTION_ID = "cart-drawer-section";

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return r.replace(/\/$/, "");
  }

  // Ask the theme's drawer to open. Falls back to the cart page if the
  // component never defines, so the shopper is never stranded.
  function openCartDrawer() {
    var drawer = document.querySelector("theme-drawer#cart-drawer, #cart-drawer");
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      return true;
    }
    var opener = document.querySelector(
      '[data-cart-drawer-open], a[href$="/cart"], [aria-controls="cart-drawer"]'
    );
    if (opener && opener.click) {
      opener.click();
      return true;
    }
    return false;
  }

  document.addEventListener("wbg:add-to-cart", function (event) {
    var form = event.target;
    var detail = event.detail || {};
    var item = detail.item;
    var button = detail.button;
    var error = detail.error;
    if (!(form instanceof HTMLFormElement) || !item) return;

    var label = button ? button.innerHTML : "";
    if (error) { error.hidden = true; error.textContent = ""; }
    if (button) { button.disabled = true; button.textContent = "Adding…"; }

    fetch(root() + "/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [item], sections: [SECTION_ID], sections_url: window.location.pathname })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || "Could not add to cart");
          return body;
        });
      })
      .then(function (body) {
        // The drawer was rendered when the page loaded, so it still shows the
        // old (empty) cart. Swap in the freshly rendered section markup that
        // came back with the add, then open it.
        var html = body && body.sections && body.sections[SECTION_ID];
        if (html) {
          var host = document.getElementById("shopify-section-" + SECTION_ID);
          if (host) {
            var parsed = new DOMParser().parseFromString(html, "text/html");
            var fresh = parsed.getElementById("shopify-section-" + SECTION_ID);
            if (fresh) host.innerHTML = fresh.innerHTML;
          }
        }
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        window.setTimeout(function () {
          if (!openCartDrawer()) window.location.assign(root() + "/cart");
        }, 60);
      })
      .catch(function (err) {
        if (error) { error.hidden = false; error.textContent = err.message || "Could not add to cart"; }
      })
      .finally(function () {
        if (button) { button.disabled = false; button.innerHTML = label; }
      });
  });
})();
